import Slider from '../slider/index';

export default (element) => {
  const init = () => {
    const sliderSelector = element.querySelector('[data-slider]');

    if (!sliderSelector) return;

    const nextButton = element.querySelector('.button-next ');
    const prevButton = element.querySelector('.button-prev');
    const slideImg = sliderSelector.querySelector('img') || sliderSelector.querySelector('svg');
    const buttonsPosition = () => {
      nextButton.style.top=`${(slideImg.offsetHeight - 16)/2}px`;
      prevButton.style.top=`${(slideImg.offsetHeight - 16)/2}px`;
    }
    window.addEventListener('resize',  () => {
      buttonsPosition();
    });

    window.addEventListener('load',  () => {
      buttonsPosition();
    });

    // eslint-disable-next-line no-unused-vars
    const slider = new Slider({
      el: sliderSelector,
      options: {
        slidesPerView: 1.31,
        spaceBetween: 10,
        centeredSlides: true,
        initialSlide: 1,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          745: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: false,
          }
        }, 
        on: {
          init(swiperInstance) {
            updateA11y(swiperInstance);
          },
          slideChangeTransitionEnd(swiperInstance) {
            updateA11y(swiperInstance);
          },
          resize(swiperInstance) {
            updateA11y(swiperInstance);
          },
        },
      },
    });
    function updateA11y(swiper) {
      const rect = swiper.el.getBoundingClientRect();
      swiper.slides.forEach(slide => {
        const slideRect = slide.getBoundingClientRect();
        const fullyVisible = slideRect.left >= rect.left &&
        slideRect.right <= rect.right;
        slide.setAttribute('aria-hidden', !fullyVisible);
        slide.setAttribute('tabindex', fullyVisible ? '0' : '-1');
      });
    }
  };

  init();
};
